import { ChamberMemberProSettingsSectionEnum } from "../../../../graphql/types";
import { GlobalSettingsSectionId } from "./common";

export const getSettingsSectionForSave = (
  sectionId: GlobalSettingsSectionId
): ChamberMemberProSettingsSectionEnum => {
  if (sectionId === "governanceGroups") {
    return ChamberMemberProSettingsSectionEnum.GovernanceSettings;
  }

  if (sectionId === "membershipSettings") {
    return ChamberMemberProSettingsSectionEnum.MembershipSettings;
  }

  if (sectionId === "emailCommunications") {
    return ChamberMemberProSettingsSectionEnum.EmailAndCommunicationSettings;
  }

  if (sectionId === "invoicingOptions") {
    return ChamberMemberProSettingsSectionEnum.InvoicingOptions;
  }

  return ChamberMemberProSettingsSectionEnum.GlobalSettings;
};
